import React from 'react';
import { Box, Stack, Typography, alpha, useTheme } from '@mui/material';
import { TrendingUp as TrendingUpIcon } from '@mui/icons-material';
import { formatCurrency } from './quotationCalculations';

const ExpectedProfitLabel = ({ profit, isArabic, label, margin, sx = {} }) => {
    const theme = useTheme();
    const profitColor = profit > 0 ? 'success' : profit < 0 ? 'error' : 'text.secondary';

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                p: 1,
                mb: 1.5,
                borderRadius: 1,
                bgcolor: profit > 0
                    ? alpha(theme.palette.success.main, 0.08)
                    : profit < 0
                        ? alpha(theme.palette.error.main, 0.08)
                        : alpha(theme.palette.action.disabledBackground, 0.2),
                border: `1px solid ${profit > 0
                    ? alpha(theme.palette.success.main, 0.3)
                    : profit < 0
                        ? alpha(theme.palette.error.main, 0.3)
                        : alpha(theme.palette.divider, 0.5)
                    }`,
                ...sx
            }}
        >
            <Stack direction="row" alignItems="center" spacing={0.5}>
                <TrendingUpIcon
                    sx={{
                        fontSize: '1rem',
                        color: `${profitColor}.main`,
                        transform: profit < 0 ? 'rotate(180deg)' : 'none'
                    }}
                />
                <Typography variant="caption" fontWeight={700} sx={{ color: 'text.secondary', fontSize: '0.75rem' }}>
                    {label || (isArabic ? 'الربح المتوقع:' : 'Expected Profit:')}
                </Typography>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={1}>
                {margin !== undefined && margin !== null && (
                    <Typography variant="caption" fontWeight={700} sx={{ color: 'text.secondary', fontSize: '0.75rem' }}>
                        ({margin}%)
                    </Typography>
                )}
                <Typography variant="subtitle2" fontWeight={800} sx={{ color: `${profitColor}.main`, fontSize: '0.85rem' }}>
                    {profit > 0 ? `+${formatCurrency(profit)}` : formatCurrency(profit)}
                </Typography>
            </Stack>
        </Box>
    );
};

export default ExpectedProfitLabel;
